const addressesApi = ({ apiClient }) => ({
  listAll(scope = 'city', params = {}) {
    return apiClient.get(`addresses/${scope}`, {}, params, {})
  },

  show(scope = 'city', id) {
    return apiClient.get(`addresses/${scope}/${id}`, {}, {}, {})
  },

  update(scope = 'city', id, payload) {
    return apiClient.put(`addresses/${scope}/${id}`, payload, {})
  },
})

export default addressesApi
